import React, { useEffect, useState } from 'react';
import TableHeaderComponent from '../../components/tableHeaderComponent';
import { useNavigate } from 'react-router-dom';
import PageLoader from '../../../../component/PageLoader';
import Table from '../../../../component/table/Table';
import sortbydot from '../../../../assets/image/sort_by_group.svg';
import Pagination from '../../../../component/pagination';
import { AdvanceFilter } from '@devoy/pharmnex-ui';
import advanceFilterOptions from '../../../../component/Filter/advanceFilterOptions';
import ConfirmationModal from '../../../../component/modal/ConfirmationModal';
import useDoctor from './hooks/useDoctor';
import {
	clearAdvanceFilter,
	removeSelectedInput,
	setAdvanceFilter,
	setAdvanceFilterPage,
	setSelectedInputValue,
} from '../../../../store/action/advanceFilter';
import { getFiltersParams } from '../../../../helper';
import AdvanceFilterSelectInput from '../../../../component/Filter/AdvanceFilterSelectInput';
import advanceFilterIcon from '../../../../assets/image/advanceFilter_white.svg';
import clearAllFilter from '../../../../assets/image/clearAllFilter.svg';
import DeleteModal from '../../components/deleteModal';
import { IoIosArrowRoundDown, IoIosArrowRoundUp } from 'react-icons/io';
import { ExportTable } from '../../../../store/action/export/Export';
import { hasPermission } from '../../../../utils/controller';
import Button from '../../../../component/ui/Button';
import DataNotFound from '../../../components/dataNotFound';
import { Plus } from 'lucide-react';
const Doctors = () => {
	const {
		user,
		doctorsList,
		doctorsParams,
		suburl,
		handlePageChange,
		onRowClick,
		handleDeselectAll,
		FilterDatalist,
		sortDataList,
		sortDirection,
		handleOnFocusSelectedFilterInput,
		handleApplyFilters,
		advanceFilterTotalPages,
		advanceFilterPage,
		advanceFilterPageSize,
		searchSelectedInputItems,
		setIsAdvanceFilterOpen,
		isAdvanceFilterOpen,
		isAdvanceFilterApplied,
		selectedInputs,
		setBulkAction,
		bulkAction,
		triggerConfirmationModal,
		deselectRows,
		isLoading,
		isLoader,
		setHeaderDropDown,
		headerDropDown,
		dispatch,
		getModalContent,
		closeModal,
		isMarkAsStatus,
		handleIsActiveStatus,
		handleOpenBulkDeleteCustomerModal,
		isDeleteModalOpen,
		setIsDeleteModalOpen,
		selectedDoctorListForDelete,
		handleBulkDelete,
		setDoctorsParams,
	} = useDoctor();
	const [advanceFilterRows, setAdvanceFilterRows] = useState([]);

	useEffect(() => {
		if (isAdvanceFilterOpen) {
			setAdvanceFilterRows(
				(selectedInputs || []).map((item) => ({
					key: item.key,
					label: item.label || item.key,
					value: item.value || '',
					options: item.data || item.options || [],
				})),
			);
		}
	}, [isAdvanceFilterOpen, selectedInputs]);

	const navigate = useNavigate();
	const getModalTitle = () => {
		if (isMarkAsStatus.isStatus === 1) {
			return 'Mark as Activate Doctors';
		} else if (isMarkAsStatus.isStatus === 0) {
			return 'Mark as Inactivate Doctors';
		}
		return 'Confirm Action';
	};

	const sortIconMap = {
		asc: <IoIosArrowRoundUp />,
		desc: <IoIosArrowRoundDown />,
	};

	const exportTableData = (param) => {
		ExportTable(param);
	};

	const doctorsTableColumn = [
		{
			field: '',
			headerClass: 'HeaderBg',
			checkboxSelection: true,
			headerCheckboxSelection: true,
			minWidth: 50,
			maxWidth: 50,
			lockPosition: true,
		},
		{
			field: 'DOCTOR NAME',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 200,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ order_by: 'asc', sort_by: 'name' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								DOCTOR NAME
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.name]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
		{
			field: 'STATUS',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 100,
			maxWidth: 150,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ order_by: 'asc', sort_by: 'status' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								STATUS
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.status]}
								</span>
							</p>
						</div>
					</div>
				);
			},
			cellRenderer: (params) => {
				const status = JSON.parse(params.data['status']);
				return (
					<p style={{ alignItems: 'center' }}>
						<span
							style={{
								color: status === 1 ? '#68C230' : '#00000',
								textAlign: 'center',
								fontSize: '12px',
							}}
						>
							{status === 1 ? 'Active' : status === 2 ? 'Inactive' : 'Draft'}
						</span>
					</p>
				);
			},
		},
		{
			field: 'BUSINESS NAME',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 200,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ order_by: 'asc', sort_by: 'business_name' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								BUSINESS NAME
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.business_name]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
		{
			field: 'EMAIL',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 100,
			maxWidth: 350,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ order_by: 'asc', sort_by: 'email' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								EMAIL
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.email]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
		{
			field: 'MOBILE',
			headerClass: 'HeaderBg right-align',
			suppressSizeToFit: true,
			minWidth: 100,
			maxWidth: 200,
			flex: 1,
			cellClass: 'right-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'end',
						}}
						onClick={() => sortDataList({ order_by: 'asc', sort_by: 'mobile' })}
					>
						<div>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								MOBILE
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.mobile]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
		{
			field: 'REGISTRATION NUMBER',
			headerClass: 'HeaderBg right-align',
			suppressSizeToFit: true,
			minWidth: 100,
			maxWidth: 200,
			flex: 1,
			cellClass: 'right-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ order_by: 'asc', sort_by: 'registration_number' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								REGISTRATION NUMBER
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.registration_number]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
	];

	return (
		<div style={{ overflow: 'auto' }}>
			<TableHeaderComponent
				bulkAction={bulkAction}
				createButton={{
					buttonName: 'Create New Doctors',
					disabled: !hasPermission('sales.doctors.create', user?.role?.role_permissions),
					handler: () => navigate(`/user/${suburl}/doctors-create`),
				}}
				closeButton={{
					showCloseButton: true,
					handler: () => {
						setBulkAction(false);
						setBulkAction([]);
						deselectRows && deselectRows();
					},
				}}
				buttons={[
					{
						id: 1,
						className: 'btn-gray',
						button: 'Print Statement',
						disabled: !hasPermission('sales.doctors.statement', user?.role?.role_permissions),
					},
					headerDropDown === 'Inactive Doctors' && {
						id: 2,
						className: 'btn-gray',
						button: 'Mark As Active',
						disabled: !hasPermission('sales.doctors.edit', user?.role?.role_permissions),
						handler: () => {
							triggerConfirmationModal(1);
						},
					},
					headerDropDown === 'Active Doctors' && {
						id: 2,
						className: 'btn-gray',
						button: 'Mark As Inactive',
						disabled: !hasPermission('sales.doctors.edit', user?.role?.role_permissions),
						handler: () => {
							triggerConfirmationModal(2);
						},
					},
					headerDropDown === 'All Doctors' && {
						id: 2,
						className: 'btn-gray',
						button: 'Mark As Active',
						disabled: !hasPermission('sales.doctors.edit', user?.role?.role_permissions),
						handler: () => {
							triggerConfirmationModal(1);
						},
					},
					headerDropDown === 'All Doctors' && {
						id: 3,
						className: 'btn-gray',
						button: 'Mark As Inactive',
						disabled: !hasPermission('sales.doctors.edit', user?.role?.role_permissions),
						handler: () => {
							triggerConfirmationModal(2);
						},
					},

					{
						id:
							headerDropDown === 'Inactive Doctors' || headerDropDown === 'Active Doctors' ? 3 : 4,
						className: 'btn-gray',
						button: 'Delete',
						disabled: !hasPermission('sales.doctors.delete', user?.role?.role_permissions),
						handler: () => handleOpenBulkDeleteCustomerModal(),
					},
				]}
				dropdownButton={
					<div className="dropdown text-end">
						<a
							className="d-block link-dark text-decoration-none dropdown-toggle"
							id="dropdownUser1"
							data-bs-toggle="dropdown"
							aria-expanded="false"
						>
							<p>{headerDropDown}</p>
						</a>
						<ul
							className="dropdown-menu font-14"
							aria-labelledby="dropdownUser1"
							style={{ minWidth: '240px' }}
						>
							<li>
								<a
									className="dropdown-item"
									onClick={() => FilterDatalist('orderBy=status&sortBy=asc', '', 'Active Doctors')}
								>
									Active Doctors
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() =>
										FilterDatalist('filterBy=status&filterValue=1', '', 'Duplicate Doctors')
									}
								>
									Duplicate Doctors
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() =>
										FilterDatalist('filterBy=status&filterValue=0', '', 'Inactive Doctors')
									}
								>
									Inactive Doctors
								</a>
							</li>
						</ul>
					</div>
				}
				advanceFilterButton={
					isAdvanceFilterApplied ? (
						<div>
							<button
								onClick={() => {
									dispatch(clearAdvanceFilter());
									setHeaderDropDown('All Doctors');
								}}
								style={{
									background: 'transparent',
									color: '#FF0000',
									fontSize: '14px',
									cursor: 'pointer',
									fontWeight: '600',
									lineHeight: '24px',
								}}
							>
								<img
									src={clearAllFilter}
									alt=""
									style={{ width: '18px', height: '18px', marginRight: '8px' }}
								/>
								Clear All Filters
							</button>
						</div>
					) : (
						<Button
							type="button"
							button="Advanced Filters"
							className="mt-0 px-4 btn-primary"
							onClick={() => setIsAdvanceFilterOpen(true)}
							icon={advanceFilterIcon}
						/>
					)
				}
				moreButton={
					<div className="dropdown text-end ms-3">
						<a
							href="#"
							className="d-block link-dark text-decoration-none"
							id="dropdownUser1"
							data-bs-toggle="dropdown"
							aria-expanded="false"
						>
							<img
								src={sortbydot}
								alt=""
							/>
						</a>
						{/* date , reason, created_at , description,status,reference_number, */}
						<ul
							className="dropdown-menu font-14"
							aria-labelledby="dropdownUser1"
							style={{ minWidth: '240px' }}
						>
							<li>
								<a className="dropdown-item sortBy">Sort By</a>
							</li>
							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
									className="dropdown-item"
									onClick={() => sortDataList({ order_by: 'asc', sort_by: 'name' })}
								>
									Name
									<span>{sortIconMap[sortDirection?.name]}</span>
								</a>
							</li>
							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
									className="dropdown-item"
									onClick={() => sortDataList({ order_by: 'asc', sort_by: 'business_name' })}
								>
									Business Name
									<span>{sortIconMap[sortDirection?.business_name]}</span>
								</a>
							</li>
							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
									className="dropdown-item"
									onClick={() => sortDataList({ order_by: 'asc', sort_by: 'email' })}
								>
									Email
									<span>{sortIconMap[sortDirection?.email]}</span>
								</a>
							</li>
							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
									className="dropdown-item"
									onClick={() => sortDataList({ order_by: 'asc', sort_by: 'updated_at' })}
								>
									Last Modified Time
									<span>{sortIconMap[sortDirection?.updated_at]}</span>
								</a>
							</li>
							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
									className={`dropdown-item ${!hasPermission('sales.doctors.export', user?.role?.role_permissions) ? 'disabled' : ''}`}
									onClick={() => exportTableData('doctors')}
								>
									Export Doctors
									<span>{sortIconMap[sortDirection?.balance]}</span>
								</a>
							</li>
						</ul>
					</div>
				}
			/>
			<div className="active-filter-wrapper">
				{isAdvanceFilterApplied && (
					<div className="active-filter-list">
						{selectedInputs.map((item) => (
							<AdvanceFilterSelectInput
								key={item.key}
								options={item?.data}
								placeholder={`Select ${item?.label}`}
								value={item?.value}
								disabled={false}
								onFocusCb={() => {
									if (item.value === '') {
										handleOnFocusSelectedFilterInput(item?.key);
									}
								}}
								onChange={(value) => {}}
								onSelect={(option) => {
									const updatedSelectedInput = selectedInputs.map((input) => {
										if (input.key === item?.key) {
											return {
												...input,
												value: option?.value,
											};
										}
										return input;
									});
									const params = getFiltersParams(updatedSelectedInput);
									handleApplyFilters(params);
									dispatch(setSelectedInputValue({ key: item?.key, value: option.value }));
								}}
								removeInput={() => {
									dispatch(removeSelectedInput({ key: item?.key }));
									if (item?.key === 'status') {
										setHeaderDropDown('All Doctors');
									}
									const params = getFiltersParams(
										selectedInputs.filter((input) => input.key !== item?.key),
									);
									handleApplyFilters(params);
								}}
								className="selectInput"
							/>
						))}
						<div className="add-filter-btn-wrapper">
							<button
								type="button"
								className="add-filter-btn"
								onClick={() => setIsAdvanceFilterOpen(true)}
							>
								<span className="add-filter-btn__icon">
									<Plus width={15} />
								</span>
								Add Filter
							</button>
						</div>
					</div>
				)}
			</div>
			{isLoading ? (
				<PageLoader />
			) : doctorsList.data.length > 0 ? (
				<Table
					row={doctorsList.data}
					coloum={doctorsTableColumn}
					className="productTable"
					onRowClick={onRowClick}
					bulkAction={bulkAction}
					action={setBulkAction}
					style={
						isAdvanceFilterApplied
							? { height: 'calc(100vh - 185px)' }
							: { height: 'calc(100vh - 148px)' }
					}
					onDeselectAll={handleDeselectAll}
				/>
			) : (
				<DataNotFound
					title={'Doctors make your network stronger!'}
					subtitle={'Add doctors to track prescriptions and stay connected.'}
					descriptionTitle={''}
					descriptionSubTitle={'Keep your doctor network organized to '}
					descriptionContent={'streamline prescription tracking and collaborations.'}
					buttonText={'Create New Doctor'}
					disabled={!hasPermission('sales.doctors.create', user?.role?.role_permissions)}
					onClick={() => navigate(`/user/${suburl}/doctors-create`)}
				/>
			)}
			{doctorsList.data.length > 0 && (
				<Pagination
					currentPage={isAdvanceFilterApplied ? advanceFilterPage : doctorsParams.page}
					totalPages={isAdvanceFilterApplied ? advanceFilterTotalPages : doctorsList.total_pages}
					onChangePage={handlePageChange}
					pageSize={isAdvanceFilterApplied ? advanceFilterPageSize : doctorsParams.page_size}
					setParam={(value) => {
						if (isAdvanceFilterApplied) {
							dispatch(setAdvanceFilterPage({ page: 1, pageSize: value }));
						} else {
							setDoctorsParams((prev) => ({
								...prev,
								page_size: value,
								page: 1,
							}));
						}
					}}
				/>
			)}
			{isMarkAsStatus.isModelOpen && (
				<ConfirmationModal
					isOpen={isMarkAsStatus.isModelOpen}
					onClose={closeModal}
					title={getModalTitle()}
					content={getModalContent()}
					onCancel={closeModal}
					onOk={() => {
						handleIsActiveStatus(isMarkAsStatus.isStatus);
						closeModal();
					}}
					loader={isLoader}
				/>
			)}

			{isDeleteModalOpen && (
				<DeleteModal
					isDeleteBulkConfirmationModalOpen={isDeleteModalOpen}
					setIsDeleteBulkConfirmationModalOpen={setIsDeleteModalOpen}
					selectedListForDelete={selectedDoctorListForDelete}
					handleBulkDelete={handleBulkDelete}
					deleteLength={bulkAction.length}
					saleTypeName={'Doctors'}
				/>
			)}

			<AdvanceFilter
				open={isAdvanceFilterOpen}
				title="Advance Filters"
				description="Note: You can create a bill for either Yet to Receive Items or Received Items."
				options={(advanceFilterOptions?.doctors || []).map((opt) => ({
					key: opt.key,
					label: opt.value || opt.label,
				}))}
				filters={advanceFilterRows}
				onChange={setAdvanceFilterRows}
				onLoadOptions={handleOnFocusSelectedFilterInput}
				onApply={(appliedParams, appliedFilters) => {
					const normalizedFilters = (appliedFilters || []).map((f) => ({
						key: f.key,
						label: f.label || f.key,
						value: f.value,
						data: f.options || [],
					}));
					dispatch(
						setAdvanceFilter({
							selectedInputs: normalizedFilters,
							isAdvanceFilterApplied: true,
						}),
					);
					setIsAdvanceFilterOpen(false);
					const paramsToApply = getFiltersParams(normalizedFilters);
					handleApplyFilters(paramsToApply);
				}}
				onReset={() => {
					dispatch(clearAdvanceFilter());
					setAdvanceFilterRows([]);
				}}
				onClose={() => {
					setIsAdvanceFilterOpen(false);
				}}
			/>
		</div>
	);
};
export default Doctors;
